import React, { useState } from 'react'
import { Button, Grid, TextField, Typography } from '@material-ui/core'
import { Alert as MuiAlert } from '@material-ui/lab'
import { useDispatch } from 'react-redux'

import filterStylesComponents from '../../../../assets/filterComponentsStyles'
import { create, dispatchAlert, update } from '../../AlertsActions'
import ConfirmModal from '../ConfirmModal'
import RichTextEditor from '../RichTextEditor'
import { formatDateTime, isEmptyHtml } from '../helpers'

const Form = ({ edit = false, data = null, id = null, handleClose }) => {
  const styles = filterStylesComponents()
  const dispatch = useDispatch()

  const [title, setTitle] = useState(data?.title || '')
  const [text, setText] = useState(data?.text || '')
  const [error, setError] = useState('')
  const [confirmOpen, setConfirmOpen] = useState(false)

  const save = async () => {
    if (!title.trim()) {
      setError('Informe o título do alerta')
      return null
    }

    if (isEmptyHtml(text)) {
      setError('Informe o texto do alerta')
      return null
    }

    setError('')

    const values = { title: title.trim(), text }
    const resp = await dispatch(edit ? update(values, id) : create(values))

    return resp?.id ? resp : null
  }

  const handleSubmit = async e => {
    e.preventDefault()

    if (await save()) handleClose()
  }

  const handleSaveAndDispatch = async () => {
    setConfirmOpen(false)

    const saved = await save()
    if (!saved) return

    await dispatch(dispatchAlert(saved.id))
    handleClose()
  }

  return (
    <form style={{ width: '100%' }} onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        {edit && data?.dispatched && (
          <Grid item xs={12}>
            <MuiAlert severity="info">
              {`Disparado em ${formatDateTime(data.dispatched_at)} para ${
                data.recipients_count
              } lavanderia(s), ${data.read_count} já leram. `}
              As alterações aparecem para quem já recebeu e a leitura não é
              zerada.
            </MuiAlert>
          </Grid>
        )}

        <Grid item xs={12}>
          <TextField
            name="title"
            variant="standard"
            label="Título"
            value={title}
            onChange={e => setTitle(e.target.value)}
            inputProps={{ maxLength: 255 }}
            required
            fullWidth
          />
        </Grid>

        <Grid item xs={12}>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            Texto *
          </Typography>
          <RichTextEditor
            value={text}
            onChange={setText}
            placeholder="Escreva o conteúdo do alerta..."
          />
        </Grid>

        {error && (
          <Grid item xs={12}>
            <Typography variant="body2" color="error">
              {error}
            </Typography>
          </Grid>
        )}

        <Grid
          item
          xs={12}
          container
          justifyContent="center"
          spacing={2}
          style={{ marginTop: '1em' }}
        >
          <Grid item>
            <Button type="submit" className={styles.btnSalvar}>
              Salvar
            </Button>
          </Grid>
          {!data?.dispatched && (
            <Grid item>
              <Button
                className={styles.btnSalvar}
                style={{ width: 'auto' }}
                onClick={() => setConfirmOpen(true)}
              >
                Salvar e disparar
              </Button>
            </Grid>
          )}
        </Grid>
      </Grid>

      <ConfirmModal
        open={confirmOpen}
        title="Salvar e disparar"
        message="O alerta será salvo e enviado para todas as lavanderias não inativas."
        confirmText="Disparar"
        onClose={() => setConfirmOpen(false)}
        onConfirm={handleSaveAndDispatch}
      />
    </form>
  )
}

export default Form
